import React from 'react';
import { Check, X } from 'lucide-react';

/**
 * Mobile / tablet view — two tier cards stacked vertically, each with
 * its own feature checklist grouped by section (per user preference).
 */

const Row = ({ feature, state }) => {
  const iconClass = state === 'yes'
    ? 'text-emerald-600'
    : state === 'no'
      ? 'text-slate-300'
      : 'text-slate-500';
  const Icon = state === 'yes' ? Check : X;
  const isText = state !== 'yes' && state !== 'no';
  return (
    <li className="flex items-start gap-2 py-1.5">
      {!isText && <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${iconClass}`} strokeWidth={state === 'yes' ? 3 : 2} />}
      <span className={`text-sm ${state === 'no' ? 'text-slate-400' : 'text-slate-700'}`}>
        {feature}
        {isText && <span className="text-slate-500"> &mdash; {state}</span>}
      </span>
    </li>
  );
};

const TierCard = ({ label, accent, tierKey, groups }) => (
  <div className={`rounded-2xl border ${accent.border} ${accent.bg} p-5 sm:p-6`} data-testid={`compare-stack-${tierKey}`}>
    <h3 className={`text-lg font-serif font-bold ${accent.text} mb-4`}>{label}</h3>
    {groups.map((group) => (
      <div key={group.title} className="mb-4 last:mb-0">
        <p className="text-xs uppercase tracking-wide text-slate-500 font-semibold mb-1">
          {group.title}
        </p>
        <ul className="space-y-0.5">
          {group.rows.map((row) => (
            <Row key={row.feature} feature={row.feature} state={row[tierKey]} />
          ))}
        </ul>
      </div>
    ))}
  </div>
);

const CompareStack = ({ groups }) => (
  <div className="lg:hidden grid grid-cols-1 gap-5" data-testid="compare-stack">
    <TierCard
      label="Continuity Tier"
      accent={{ border: 'border-teal-200', bg: 'bg-teal-50/50', text: 'text-teal-800' }}
      tierKey="continuity"
      groups={groups}
    />
    <TierCard
      label="Clarity Tier"
      accent={{ border: 'border-emerald-200', bg: 'bg-emerald-50/50', text: 'text-emerald-800' }}
      tierKey="premium"
      groups={groups}
    />
  </div>
);

export default CompareStack;
